import { injectable } from 'inversify-props';
import BaseService from '@/services/base-service';
import StockCentralResponse from '@/models/b2b/stock-central-response.model';
import StockCentralFilter from '@/models/b2b/stock-central-filter.model';

@injectable()
export default class StockCentralService extends BaseService {
  async getStock(filters?: StockCentralFilter): Promise<StockCentralResponse> {
    try {
      // Validar que há pelo menos um filtro válido
      if (!filters) {
        throw new Error('É necessário informar filtros para buscar');
      }

      const hasReferences = filters.references && filters.references.length > 0;

      if (!hasReferences) {
        throw new Error('É necessário informar algum valor no campo de pesquisa para buscar possíveis resultados.');
      }

      const response = (await this.httpService.post(
        StockCentralResponse,
        `${this.getApiPath()}/stock-central`,
        filters,
        undefined,
        false,
      )) as StockCentralResponse;

      return response;
    } catch (error: any) {
      console.error('❌ [StockCentralService] Erro ao buscar estoque central:', error);
      throw error;
    }
  }
}
